var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{staticStyle:{"margin":"30px 0"},attrs:{"id":"report-chart-card","height":"463","type":"card-heading, image, image"}})}
var staticRenderFns = []

export { render, staticRenderFns }